import { render, staticRenderFns } from "./ProdukDetail.vue?vue&type=template&id=714c1e74&scoped=true"
import script from "./ProdukDetail.vue?vue&type=script&lang=js"
export * from "./ProdukDetail.vue?vue&type=script&lang=js"
import style0 from "./ProdukDetail.vue?vue&type=style&index=0&id=714c1e74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714c1e74",
  null
  
)

export default component.exports